import {
  mapCmsImageToHeroImagesProps,
  mapCmsBlogPostsToBlogPostCardsProps,
} from '@/lib/cms-mappers';

import type { FcwBlogHomeTemplateProps } from '@/components/templates/FcwBlogHomeTemplate.vue';

export function mapCmsBlogDataToBlogHomeProps(
  blogHomeRawData: StrapiResponseData<BlogContentType> | undefined,
  blogPostsRawData: StrapiResponseData<BlogPostContentType>[] | undefined
): FcwBlogHomeTemplateProps {
  const blogHomeData = blogHomeRawData?.attributes;

  return {
    hero: {
      images: mapCmsImageToHeroImagesProps(blogHomeData?.hero?.image),
      title: blogHomeData?.hero?.title ?? '',
      subtitle: blogHomeData?.hero?.subtitle ?? '',
    },
    blogPostCards: mapCmsBlogPostsToBlogPostCardsProps(blogPostsRawData),
  };
}
